<template>
  <el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick" :before-leave="checkTab">

    <!-- 新添加 start -->
    <slot></slot>
    <!-- 新添加 end -->

    <el-tab-pane label="GLOBE" name="first" :theType="theType">
      <div class="recharge_hurg">
        <div class="title">选择Globe话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in globe.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination, item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <div>
              {{item.price_format}}P 话费
            </div>
            <div class="des">
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>

      <div class="recharge_hurg">
        <div class="title">选择Globe流量套餐</div>
        <div class="wrap_select" v-if="globe.wifiliul && globe.wifiliul.length > 0">
          <el-tabs v-model="activeName_child" :stretch="true" @tab-click="handleClick" class="el-tabs-child">
            <el-tab-pane label="流量套餐" name="list1">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in globe.liul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>
                </li>
                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in globe.liul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>
                </li>
              </ul>
              <div v-if="globe.liul && globe.liul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="WiFi套餐" name="list2">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in globe.wifiliul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in globe.wifiliul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>

                </li>
              </ul>
              <div v-if="globe.wifiliul && globe.wifiliul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>

                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="国际长途" name="list3">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in globe.gj"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in globe.gj" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>

                </li>
              </ul>
              <div v-if="globe.gj && globe.gj.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>

                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <ul v-else>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in globe.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <div>
              <!-- ￥{{item.count}} -->
              {{item.sub_title}}
            </div>
            <div class="des">
              <!-- {{item.sub_title}} -->
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>
    </el-tab-pane>

    <el-tab-pane label="TM" name="two" :theType="theType">
      <div class="recharge_hurg">
        <div class="title">选择TM话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in tm.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination, item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <div>
              {{item.price_format}}P 话费
            </div>
            <div class="des">
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>

      <div class="recharge_hurg">
        <div class="title">选择TM流量套餐</div>
        <div class="wrap_select" v-if="tm.wifiliul && tm.wifiliul.length > 0">
          <el-tabs v-model="activeName_child" :stretch="true" @tab-click="handleClick" class="el-tabs-child">
            <el-tab-pane label="流量套餐" name="list1">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in tm.liul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>
                </li>
                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in tm.liul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>
                </li>
              </ul>
              <div v-if="tm.liul && tm.liul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="WiFi套餐" name="list2">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in tm.wifiliul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in tm.wifiliul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>

                </li>
              </ul>
              <div v-if="tm.wifiliul && tm.wifiliul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>

                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="国际长途" name="list3">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in tm.gj"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in tm.gj" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    <!-- ￥{{item.count}} -->
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    <!-- {{item.sub_title}} -->
                    仅售 {{item.count}} Rmb
                  </div>

                </li>
              </ul>
              <div v-if="tm.gj && tm.gj.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>

                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <ul v-else>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in tm.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <div>
              <!-- ￥{{item.count}} -->
              {{item.sub_title}}
            </div>
            <div class="des">
              <!-- {{item.sub_title}} -->
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>
    </el-tab-pane>

    <el-tab-pane label="SMART/TNT" name="second">
      <div class="recharge_hurg">
        <div class="title"> 选择SMART/TNT话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in smart.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <div>
              {{item.price_format}}P 话费
            </div>
            <div class="des">
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>

      <div class="recharge_hurg">
        <div class="title">选择SMART/TNT流量套餐</div>
        <div class="wrap_select" v-if="smart.wifiliul && smart.wifiliul.length > 0">
          <el-tabs v-model="activeName_child" :stretch="true" @tab-click="handleClick" class="el-tabs-child">
            <el-tab-pane label="流量套餐" name="list1">
              <ul>
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in smart.liul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    仅售 {{item.count}} Rmb
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in smart.liul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    仅售 {{item.count}} Rmb
                  </div>

                </li>
              </ul>
              <div v-if="smart.liul && smart.liul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="WiFi套餐" name="list2">
              <ul>
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in smart.wifiliul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    仅售 {{item.count}} Rmb
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in smart.wifiliul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
                  <!-- 商品icon -->
                  <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
                  <div>
                    {{item.sub_title}}
                  </div>
                  <div class="des">
                    仅售 {{item.count}} Rmb
                  </div>
                </li>
              </ul>
              <div v-if="smart.wifiliul && smart.wifiliul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <!-- <el-tab-pane label="国际长途" name="list3">
              <ul>
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in smart.gj"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <div>
                    ￥{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in smart.gj" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <div>
                    ￥{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>
                </li>
              </ul>
              <div v-if="smart.gj && smart.gj.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane> -->
          </el-tabs>
        </div>

        <ul v-else>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in smart.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <div>
              {{item.sub_title}}
            </div>
            <div class="des">
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>
    </el-tab-pane>

    <el-tab-pane label="DITO" name="four">
      <div class="recharge_hurg">
        <div class="title"> 选择DITO话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in dito.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <div>
              {{item.price_format}}P 话费
            </div>
            <div class="des">
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>
      <div class="recharge_hurg">
        <div class="title">选择DITO流量套餐</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in dito.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <div>
              {{item.sub_title}}
            </div>
            <div class="des">
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>
    </el-tab-pane>

    <el-tab-pane label="SUN" name="third">
      <div class="recharge_hurg ">
        <div class="title"> 选择SUN话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in sun.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
            <div>
              {{item.price_format}}P 话费
            </div>
            <div class="des">
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>

      <div class="recharge_hurg ">
        <div class="title">选择SUN流量套餐</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in sun.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination,item)">
            <!-- 商品icon -->
            <img v-if="item.ico" :src="item.ico" class="product-icon" alt="商品图标" />
            <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
            <div>
              {{item.sub_title}}
            </div>
            <div class="des">
              仅售 {{item.count}} Rmb
            </div>
          </li>
        </ul>
      </div>
    </el-tab-pane>



    <!-- <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false"
    :direction="direction" :size="size" style="max-width:750px;margin:0 auto;">
      <div class="drawer">
        <div class="cancle">
          <i class="iconfont el-icon-close" @click="closeDrawer"></i>
        </div>
        <div class="drawer-cell ">
          <div class="drawer-cell_hd">充值金额</div>
          <div class="drawer-cell_bd">{{thePrice}}</div>
        </div>
        <div class="drawer-cell ">
          <div class="drawer-cell_hd">实付金额</div>
          <div class="drawer-cell_bd">{{codemoney !== ""?codemoney:thePrice}}</div>
        </div>
        <div class="drawer-cell under-line">
          <div class="drawer-cell_hd">手机号码</div>
          <div class="drawer-cell_bd redclass">{{theNumber!='NaN'?theNumber:"请输入手机号码充值"}}</div>
        </div>
        <div class="drawer-cell">
          <div class="drawer-cell_hd">服&ensp;务&ensp;商</div>
          <div class="drawer-cell_bd">{{operators}}</div>
        </div>
        <div class="drawer-cell" style="color: #c82f08;text-align: left;" v-if="combination">
          重要提示：此为组合套餐，失败将退款到余额
        </div>
        <div class="drawer-cell" style="color: #c82f08;text-align: left;" v-if="!combination && radio==2">
          重要提示：使用余额支付，失败将退款到余额
        </div>
        <div class="drawer-cell" style="height:auto" v-if="theNumber!='NaN' && coupons.length == 0">
          <div class="drawer-cell_hd">
            优&ensp;惠&ensp;码
          </div>
          <div class="drawer-cell_bd intro flex">
            <el-input v-model="code" placeholder="请输入优惠代码" size="small" maxlength="12" class='mar-right-5'
              v-if="codetoken==''"></el-input>
            <el-button type="primary" size="mini" plain @click="verificationcodefun" v-if="codetoken==''">兑换
            </el-button>
            <div class='mar-right-5 xcode' v-if="codetoken!=''">{{code}}</div>
          </div>
        </div>
        <div class="drawer-cell" style="height:auto" v-if="coupons.length > 0">
          <div class="drawer-cell_hd"  style="line-height:40px">
            优&ensp;惠&ensp;券
          </div>
          <div class="drawer-cell_bd intro flex">
            <el-select v-model="coupon_id" @change="couponChange" placeholder="请选择">
              <el-option
                v-for="item in coupons"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="drawer-cell" style="height:auto">
          <div class="drawer-cell_hd">套餐介绍</div>
          <div class="drawer-cell_bd intro ">{{theDetail}}</div>
        </div>
        <div class="drawer-cell">
          <div class="drawer-cell_hd">充值方式</div>
          <div class="myredioBox">
            <div class="myredioleabl" :class="radio==1?'myredioleablAc':''" @click="checkedValuefun(1)">
              <div class="myredio">
                <div></div>
              </div>
              <div class="myrediotext">直充</div>
            </div>
            <div class="myredioleabl" :class="radio==2?'myredioleablAc':''" @click="checkedValuefun(2)"
              v-if="codetoken==''">
              <div class="myredio">
                <div></div>
              </div>
              <div class="myrediotext">余额充值</div>
            </div>
          </div>
        </div>
        <div class="drawer-cell payment-radio" v-if="$client == 'h5' && configPayments && configPayments.length > 1">
         <div class="drawer-cell_hd">支付方式</div>
          <el-radio-group
          v-model="payment"
          size="small"
          @change="handleRadioChange" class="group-flex" >
            <el-radio
              :label="item.code"
              v-for="item in configPayments"
              :key="item.code"
              class="radio-flex"
            >
              <img :src="item.icon || '../../static/images/'+item.name+'.png'" >
            </el-radio>
          </el-radio-group>
        </div>

        <div class="btn-area" v-if="theNumber!='NaN'">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <el-button type="info" class="half" @click="closeDrawer">取消支付</el-button>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-button type='primary' @click="order" v-loading.fullscreen.lock="fullscreenLoading"
                  class="half">确认支付</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-drawer> -->

    <!-- 新添加代码 start -->
    <div class="confirm-order">
      <el-dialog
        :title="theNumber ? '订单确认': '套餐信息'"
        :visible.sync="drawer"
        width="93.6%"
      >
        <div class="flex-column">
          <div v-if="theNumber" class="drawer-cell">
            <div class="drawer-cell_hd">手机号码</div>
            <div class="drawer-cell_bd phone flex-column">
              <div v-if="theNumber" class="flex-column">
                <div class="value">{{theNumber}}</div>
                <div class="tips">请仔细核对号码，充错号订单成功运营商无法退还。</div>
              </div>
              <div class="value" v-else>--</div>
            </div>
          </div>
          <div v-else class="drawer-cell">
            <div class="phone-tips">
              如需充值请先填写手机号
            </div>
          </div>
          <!-- <div class="drawer-cell">
            <div class="drawer-cell_hd">充值金额</div>
            <div class="drawer-cell_bd">{{thePrice}}</div>
          </div>
          <div class="drawer-cell ">
            <div class="drawer-cell_hd">实付金额</div>
            <div class="drawer-cell_bd">{{codemoney !== ""?codemoney:thePrice}}</div>
          </div> -->
          <div class="drawer-cell">
            <div class="drawer-cell_hd">服&ensp;务&ensp;商</div>
            <div class="drawer-cell_bd">{{operators || '--'}}</div>
          </div>
          <div class="drawer-cell" style="color: #B42027;text-align: left;font-size: 15px;" v-if="combination">
            重要提示：此为组合套餐，失败将退款到钱包
          </div>
          <div class="drawer-cell" style="color: #B42027;text-align: left;font-size: 15px;" v-if="!combination && radio==2">
            重要提示：使用钱包支付，失败将退款到钱包
          </div>
          <div class="drawer-cell" style="height:auto" v-if="coupons.length > 0">
            <div class="drawer-cell_hd"  style="line-height:40px">
              优&ensp;惠&ensp;券
            </div>
            <div class="drawer-cell_bd intro flex">
              <el-select v-model="coupon_id" @change="couponChange" placeholder="请选择">
                <el-option
                  v-for="item in coupons"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="drawer-cell" style="height:auto">
            <div class="drawer-cell_hd">套餐详情</div>
            <div class="drawer-cell_bd intro ">{{theDetail}}</div>
          </div>
          <!-- v-if="theNumber && coupons.length == 0" -->
          <div class="drawer-cell flex-row" style="height:auto" >
            <div class="drawer-cell_hd">
              优&ensp;惠&ensp;码
            </div>
            <div class="drawer-cell_bd intro flex yhm">
              <el-input v-model="code" placeholder="如没有可不填" size="small" maxlength="12" class='mar-right-5'
                v-if="codetoken==''"></el-input>
              <el-button type="primary" size="mini" plain @click="verificationcodefun" v-if="!codetoken">兑换
              </el-button>
              <div class='mar-right-5 xcode' v-if="codetoken">{{code}}</div>
            </div>
          </div>
          <div class="drawer-cell">
            <div class="drawer-cell_hd">支付类型</div>
            <div class="myredioBox">
              <div class="myredioleabl" :class="radio==1?'myredioleablAc':''" @click="checkedValuefun(1)">
                <div class="myredio">
                  <div></div>
                </div>
                <div class="myrediotext">直充</div>
              </div>
              <div class="myredioleabl" :class="radio==2?'myredioleablAc':''" @click="checkedValuefun(2)"
                v-if="codetoken==''">
                <div class="myredio">
                  <div></div>
                </div>
                <div class="myrediotext">钱包支付</div>
              </div>
            </div>
          </div>
          <div class="drawer-cell ">
            <div class="drawer-cell_hd">支付金额</div>
            <div class="drawer-cell_bd phone">
              <div class="value">{{codemoney ?codemoney:thePrice}} RMB</div>
            </div>
          </div>
          <!-- <div class="drawer-cell payment-radio" v-if="$client == 'h5' && payments.length > 1">
           <div class="drawer-cell_hd">支付方式</div>
            <el-radio-group
            v-model="payment"
            size="small"
            @change="handleRadioChange" class="group-flex" >
              <el-radio
                :label="item.code"
                v-for="item in payments"
                :key="item.code"
                class="radio-flex"
              >
                <img :src="'../../static/images/'+item.name+'.png'" >
              </el-radio>
            </el-radio-group>
          </div> -->
          <div class="drawer-cell drawer-cell-payments" v-if="$client == 'h5' && configPayments && configPayments.length > 1 && radio == 1">
            <div class="drawer-cell_hd">支付方式</div>
            <div class="flex-1">
              <div v-for="item in configPayments" :key="item.code" class="myredioBox">
                <div class="myredioleabl" :class="payment==item.code?'myredioleablAc':''"
                @click="paymentValuefun(item.code)">
                  <div class="myredio">
                    <div></div>
                  </div>
                  <div class="myrediotext flex-1">
                    <img :src="item.icon || '../../static/images/'+item.name+'.png'" >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="theNumber" class="submit flex-row">
            <div class="cancel flex-center" @click="closeDrawer">
              <span>取消</span>
            </div>
            <div class="confirm flex-1 flex-center" @click="orderModel">
              <span>确认支付</span>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 新添加代码 end -->


    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
      <div>
        <!--  <span>需要注意的是内容是默认不居中的</span> -->
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
          :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </el-tabs>

</template>

<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      // clearTimeout(timer)
      setTimeout(() => {
        clearInterval(timer)
      }, 1000 * 60 *  5)
      if (timer) clearInterval(timer)
      timer = setInterval(callback, ms)
    }
  })()

  import vueQr from 'vue-qr'
  import wx from 'weixin-js-sdk';
  import config from '@/config';

  export default {
    name: 'tabs',
    components: {
      vueQr,
      wx
    },
    data() {
      return {
        more: false,
        code: "",
        codemoney: "",
        codestatus: true,
        codetoken: "",
        radio: 1,
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
          // icon: require('./xxx.jpg')  //二维码中间的图片,可以不设置
        },
        activeName: "first",
        activeName_child: "list1",
        direction: "btt",
        drawer: false, //
        thePrice: 10,
        status: 0,
        theDetail: "",
        combination: null,
        size: "60%",
        theNumber: "NaN",
        theNumber: "",
        // operators: "NaN",
        operators: "",
        opertaorsId: 1,
        tabValue: true,
        payment: 'weixin',
        i: 0,
        fullscreenLoading: false,
        isOrder: false,
        coupon_id: '',
        coupon: {},
      }
    },
    props: {
      coupons: Array,
      theType: Object,
      globe: Object,
      smart: Object,
      sun: Object,
      tm: Object,
      dito: Object,
      payments: Array,
      configPayments: Array,
    },
    computed: {
      tabStatusChanged() {
        return this.$store.state.tabStatus;
      }
    },
    watch: {
      code(n, o) {
        this.code = this.code.toUpperCase();
      },
      tabStatusChanged(now) {
        if (now <= 0) {
          this.status = now;
        }
      },
      // 监听 configPayments 的变化
      configPayments(newVal, oldVal) {
        console.log('tabs.vue watch configPayments 变化:', {
          newVal: newVal,
          oldVal: oldVal
        });
      },
      // 父组件通过PROPS（theType）传值到子组件，通过watch监控props值改变，修改相对应的值
      //**如果PROPS为OBJ，WATCH无法监控其属性,因为在父组件时，修改的是其属性。而对象未发生改变**
      theType() {
        this.theNumber = this.theType.number;
        this.tabValue = this.theType.value;
        this.i = 0;
        this.chooseChannel(this.theType.id);
      }
    },
    mounted() {
      this.chooseChannel(this.theType.id);
      console.log('tabs.vue mounted:', {
        configPayments: this.configPayments
      });
    },
    updated() {
      console.log('tabs.vue updated:', {
        configPayments: this.configPayments
      });
    },
    methods: {
      couponChange(e) {
        this.coupons.forEach((item) => {
          if (item.id == e) {
            this.coupon = item;
            this.coupon_id = item.id;
          }
        })
        this.updatePrice();
      },
      chooseChannel(type) {
        switch (type) {
          case 1:
            this.activeName = "first";
            this.opertaorsId = 1;
            this.operators = "GLOBE/TM";
            break;
          case 2:
            this.activeName = "second";
            this.opertaorsId = 2;
            this.operators = "SMART/TNT";
            break;
          case 3:
            this.activeName = "third";
            this.opertaorsId = 3;
            this.operators = "SUN";
            break;
          case 4:
            this.activeName = "four";
            this.opertaorsId = 4;
            this.operators = "DITO";
            break;
        }
      },
      changeType() {
        var that = this;
        if (this.more) {
          this.more = false;
        } else {
          this.more = true;
        }
      },
      onloadcode() {
        this.codemoney = '';
        this.code = "";
        this.codestatus = true;
        this.codetoken = "";
      },
      verificationcodefun() {
        if (this.combination) {
          this.$message({
            message: "不支持当前套餐",
            type: "warning"
          })
          return false;
        }
        if (this.radio == 2) {
          this.$message({
            message: "不支持当前支付方式",
            type: "warning"
          })
          return false;
        }
        if (this.code) {
          this.$api
            .request('Order/verifyPromoCode', {code: this.code, money: this.thePrice})
            .then(({ data }) => {
                this.codestatus = false;
                this.codemoney = data.codemoney;
                this.codetoken = data.codetoken;
            })
            .catch(error => {
              this.$message({
                message: error,
                type: "warning"
              })
            });
        } else {
          this.$message({
            message: "请输入优惠代码",
            type: "warning"
          })
        }
      },
      checkedValuefun(e) {
        this.radio = e;
      },
      paymentValuefun(code) {
        // console.log(code)
        this.payment = code
      },
      openUrl(url) {
        if (url) {
          window.open(url, '_blank');
        }
        this.$confirm("支付提示","",{
          iconClass: "el-icon-question",//自定义图标样式
            confirmButtonText: "支付完成",//确认按钮文字更换
            cancelButtonText: "取消",//取消按钮文字更换
            showClose: true,//是否显示右上角关闭按钮
            type: "warning",//提示类型  success/info/warning/error
        }).then((data) => {
          let auth_token = localStorage.getItem('auth_token');
          if (auth_token) {
            this.$router.push('/historycard');
          }
        }).catch((err) => {

        });
      },
      orderModel() {
         const orderTips = localStorage.getItem('orderTips');
        this.$confirm(orderTips, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
           this.order()
        })
      },
      order() {
        this.drawer = false;
        if (this.isOrder) {
          this.$message({
            message: "请勿重复下单",
            type: "warning"
          })
          return false;
        }
        this.isOrder = true;

        let auth_token = localStorage.getItem('auth_token');
        if ((this.$client == 'wxh5' || this.$client == 'magapp') && !auth_token) {
            this.$message({
              message: "请登录后下单！",
              type: "warning"
            })
            this.$emit("checkLogin", {});
            return false;
        }
        if (!auth_token && this.radio == 2) {
          this.$message({
            message: "未登录不能使用余额支付",
            type: "warning"
          })
          return false;
        }
        if (this.radio == 1 && this.combination) {
          this.$message({
            message: "组合套餐不能使用在线支付",
            type: "warning"
          })
          return false;
        }
        let phone = this.theNumber;
        if (typeof this.theType.numbers != 'undefined' && this.theType.numbers.length > 0) {
          phone = this.theType.numbers.join(',');
        }
        
        this.$api.request('Order/create', {
            type: this.radio,
            settlement: config.SETTLEMENT,
            phone: phone,
            itemid: this.status,
            client: this.$client,
            code: this.code,
            payment: this.payment,
            codetoken: this.codetoken,
            coupon_id: this.coupon_id,
           })
          .then(({ data }) => {
            this.isOrder = false;
            if (this.coupon_id > 0) {
              let coupon_select_index = this.coupons.findIndex(citem => {
                return citem.id === this.coupon_id;
              })
              this.coupons.splice(coupon_select_index, 1);
              this.coupon = {};
              this.coupon_id = '';
            }
            if (data.result == true) {
              this.$message({
                message: "支付成功！",
                type: "success"
              })
            } else if (data.result && data.result.new == true) {
              // 新支付返回结构
              let paymentType = data.result.payment_type || 'link';
              let out_trade_no = data.result.sn || data.result.order_no || '';
              console.log('paymentType:', paymentType)
              switch(paymentType) {
                case 'qrcode':
                  // 显示二维码弹窗
                  this.centerDialogVisible = true;
                  this.downloadData.url = data.result.pay_url || '';
                  if (out_trade_no) {
                    delay(() => {
                      this.checkorder(out_trade_no)
                    }, 3000)
                  }
                  break;  
                case 'link':
                  // 打开链接
                  this.openUrl(data.result.pay_url);
                  break;
                case 'jsapi':
                  // jsapi类型：调用微信支付
                  this.wxpay(data.result);
                  break;
                case 'app':
                  // app类型：调用马甲APP支付
                  this.magpay(data.result);
                  break;
                default:
                  this.$message({
                    message: "暂不支持的支付类型！",
                    type: "warning"
                  })
                  break;
              }
            } else {
              let out_trade_no = '';
              switch(this.$client) {
                case 'h5':
                  if (this.payment == 'weixin') {
                    if (data.result.is_wap) {
                      this.openUrl(data.result.h5_url);
                    } else {
                      this.centerDialogVisible = true;
                      this.downloadData.url = data.result.code_url;
                      out_trade_no = data.result.out_trade_no;
                    }
                  } else {
                    switch (data.type) {
                      case "1":
                        if (this.payment == 'gcashpay') {
                          this.openUrl(data.result.data.content);
                        } else {
                          this.centerDialogVisible = true;
                          this.downloadData.url = data.result.data.content;
                          out_trade_no = data.result.data.outTradeNo;
                        }
                        break;
                      case "2":
                        switch (this.payment) {
                          case "alipay":
                            this.centerDialogVisible = true;
                            this.downloadData.url = data.result.results.pay_url;
                            out_trade_no = data.result.results.out_trade_no;
                            break;
                          case "gcashpay":
                            this.openUrl(data.result.results.api_url);
                            break;
                        }
                        break;
                      default:
                        this.$message({
                          message: "暂不支持的支付类型！",
                          type: "warning"
                        })
                        break;
                    }
                  }

                  if (out_trade_no != '') {
                    delay(() => {
                      this.checkorder(out_trade_no)
                    }, 3000)
                  }
                  break;
                case 'wxh5':
                  this.wxpay(data.result);
                  break;
                case 'magapp':
                  this.magpay(data.result);
                  break;
                default:
                  this.$message({
                    message: "暂不支持的客户端！",
                    type: "warning"
                  })
                  break;
              }
            }
          })
          .catch(error => {
            this.isOrder = false;
            this.$message({
              message: error,
              type: "warning"
            })
          });
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.paySign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {sn})
          .then(({ data }) => {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
      closeDrawer() {
        this.drawer = false
      },
      // 切换TABS前，进行判断，当前运营商（activename）与this.type.id是否一致？？？
      // XXXX需要的是在正确的条状一次后，禁止掉后续的跳转(不可行，因为在)
      checkTab(act, oact) {
        this.$store.commit('setTab', act);

        // if (this.theType.id > 0 && this.activeName != act) {
        //   this.$message({
        //     message: "号段与运营商需匹配",
        //     type: "warning"
        //   })
        //   return false
        // }

        //在跳转之前进行判断，TABS不可以跳转
        // 当输入号码后进入这段判断
        //接房方法找到原有的，判断，或者INIT原有状态。
        // if (act == oact || this.activeName == oact) {
        //   this.i++
        // }
        // if (!this.tabValue) {
        //   // 问题出在这里，tabvalue 需要执行一次。
        //   //i<1时不执行，i>0时执行

        //   //新的问题：当前activename即输入号码段时，不用PROPS修改，但是用户又手残去点击了一次。
        //   // 如何解决？817号段，即号码输入号码就是第一个运营商的（方法错误。）即不需要发生修改运营商

        //   if (this.i < 1) {
        //     this.i++;
        //     return true
        //   };
        //   // 弹出error框体

        //   if (this.i > 0) {
        //     this.$message({
        //       message: "号段与运营商需匹配",
        //       type: "warning"
        //     })
        //     return false
        //   }
        // }
        // if (!this.tabValue && this.i > 0) {
        //   this.$message({
        //     message: "号段与运营商不匹配",
        //     type: "warning"
        //   })
        //   // 问题出在这里，tabvalue 需要执行一次。
        //   this.i++;
        //   return false
        // }
      },
      handleRadioChange(e) {
        this.payment = e;
      },
      handleClick(tab, event) {
      },
      // 弹窗，1、验证（如果可以，禁止点击其他tabs），可点击，判断号码与运营商是否一致。2、装载相应数据。
      choicePrice(index, price, desc, combination, item) {
        // console.log(item)
        this.status = index;
        var num = this.theType.number;
        
        // 检查是否是批量充值场景：有 numbers 且没有单个 number
        var isBatchRecharge = typeof this.theType.numbers != 'undefined' && 
                              this.theType.numbers.length > 0 && 
                              (!num || num == "" || num == "NaN");
        
        if (isBatchRecharge) {
          // 批量充值：只能钱包支付
          this.theNumber = '批量充值';
          this.thePrice = price * this.theType.numbers.length;
          this.code = "";
          this.codemoney = "";
          this.codestatus = true;
          this.codetoken = "";
          this.drawer = true
          this.theDetail = desc
          this.combination = combination
          this.radio = 2;

          // 使用 configPayments
          if (this.configPayments && this.configPayments.length == 1) {
            let current_payment = this.configPayments[0];
            this.payment = current_payment.code;
          }
        } else {
          this.$store.commit('setTabStatus', index);
          this.$store.commit('setTab2Status', 0);
          var bl = this.common.test(num);
          if (num == "" || num == "NaN" || !num) {
            this.thePrice = price
            this.code = "";
            this.codemoney = "";
            this.codestatus = true;
            this.codetoken = "";
            this.radio = 1;
            this.drawer = true
            this.theDetail = desc
            this.combination = combination
          } else {
            //判断号码是否为菲律宾号码段，符合10位
            var reg = /^(8|08|9|09)[0-9]{9}$/;
            if (this.common.test(num) && num.match(reg)) {
              this.thePrice = price
              this.code = "";
              this.codemoney = "";
              this.codestatus = true;
              this.codetoken = "";
              this.drawer = true
              this.theDetail = desc
              this.combination = combination
              if (combination) {
                this.radio = 2;
              } else {
                this.radio = 1;
              }

              // 使用 configPayments
              if (this.configPayments && this.configPayments.length == 1) {
                let current_payment = this.configPayments[0];
                this.payment = current_payment.code;
              }
            } else {
              this.$message({
                message: "请输入正确的菲律宾手机号码",
                type: "warning"
              })
            }
          }
        }
        this.updatePrice();
      },
      updatePrice() {
        if (this.coupons.length > 0 && this.coupon_id == '' && this.thePrice > 0) {
          for (let item of this.coupons) {
            if (item['limit'] <= this.thePrice) {
              this.coupon = item;
              this.coupon_id = item.id;
            }
          }
        }
        if (this.coupon_id > 0 && this.thePrice > 0) {
          if (this.thePrice < this.coupon['limit']) {
              this.$message({
                message: "此优惠券不满足使用条件",
                type: "warning"
              })
              this.coupon_id = '';
              this.coupon = {};
              this.codemoney = "";
          } else {
            this.codemoney = this.thePrice - this.coupon['amount'];
          }
        }
      }
    }
  }
</script>
<style scoped>

  .phone-tips {
    color: #B42027;
    font-family: 思源黑体 CN;
    font-size: 15px;
    font-weight: 400;
    line-height: 25px;
  }

  .confirm-order .submit {
    padding-left: 5px;
    margin-top: 6px;
  }

  .confirm-order .submit .cancel {
    width: 64px;
    height: 24px;
    margin-right: 12px;
  }

  .confirm-order .submit .cancel span {
    color: #969799;
    font-family: 思源黑体;
    font-size: 15px;
    line-height: 17px;
  }

  .confirm-order .submit .confirm {
    height: 31px;
    border-radius: 5px;
    /* Status / Red */
    background: linear-gradient(180.00deg, rgb(237, 58, 66),rgb(163, 24, 31) 100%);
  }

  .confirm-order .submit .confirm span {
    color: #fff;
    font-family: 思源黑体;
    font-size: 15px;
    font-weight: 700;
    line-height: 15px;
  }

  .confirm-order .submit .confirm:active {
    opacity: .7;
  }

  /deep/ .confirm-order .el-dialog {
    max-width: 360px !important;
    border-radius: 15px;
  }

  /deep/ .confirm-order .el-dialog__header {
    padding: 11px 12px 10px 12px;
    box-sizing: border-box;
  }

  /deep/ .confirm-order .el-dialog__title {
    color: #686777;
    font-family: 思源黑体;
    font-size: 15px;
    font-weight: 500;
    line-height: 24px;
    height: 24px;
    letter-spacing: 0.7px;
  }

  /deep/ .confirm-order .el-dialog__headerbtn {
    top: 13px;
    right: 15px;
    font-size: 18px;
    color: #C8C9CC !important;
  }

  /deep/ .confirm-order .el-dialog__body {
    padding: 6.71px 10px 10px;
    box-sizing: border-box;
  }

  .confirm-order .drawer-cell {
    height: auto !important;
    /* margin-bottom: 6px; */
    margin-bottom: 8px;
  }

  .confirm-order .drawer-cell .phone .value {
    color: #B42027;
    font-family: 思源黑体 CN;
    font-size: 19px;
    font-weight: 500;
    height: 24px;
    line-height: 20px;
  }

  .confirm-order .drawer-cell .phone .tips {
    color: #000;
    font-family: 思源黑体 CN;
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;
    margin-top: 5px;
  }

  .confirm-order .drawer-cell_hd {
    color: #686777;
    font-family: 思源黑体 CN;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    height: 24px;
  }

  .el-select-dropdown__item {
    width: 100%;
    margin-bottom: 0px;
  }

  .payment-radio {
/*    padding: 20px 0 0 0; */
    flex-wrap: wrap;
  }

  .myredioBox {
    text-align: right;
    width: 70%;
    color: #666;
    display: flex;
  }

  .myredioleabl {
    /* height: 2rem;
    line-height: 2rem; */
    height: 23px;
    line-height: 23px;
    width: 48%;
    /* margin-right: 15px; */
    /* width: auto; */
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .myrediotext {
    /* float: right; */
    color: #4D4F53;
    font-family: Noto Sans;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
  }

  .myredio {
    /* float: right; */
    /* width: 0.8rem;
    height: 0.8rem; */
    width: 14px;
    height: 14px;
    background-color: #ffffff;
    border-radius: 50%;
    /* margin-right: 0.5rem; */
    margin-right: 2px;
    /* margin-top: 0.6rem; */
    border: 1px solid rgb(104, 103, 119);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .myredioleabl .myredio {
    border: 0.3px solid rgb(104, 103, 119);
  }

  .myredioleablAc .myredio {
    border: 0.3px solid rgb(180, 32, 39);
  }

  .myredioleabl .myredio div {
    /* width: 0.6rem;
    height: 0.6rem; */
    width: 10px;
    height: 10px;
    /* border-radius: 0.6rem; */
    border-radius: 50%;
    /* margin: 0 auto; */
    /* margin-top: 0.1rem; */
    background-color: #FFFFFF;
  }

  .myredioleablAc .myredio div {
    /* width: 0.6rem;
    height: 0.6rem; */
    width: 10px;
    height: 10px;
    /* border-radius: 0.6rem; */
    border-radius: 50%;
    /* margin: 0 auto; */
    /* margin-top: 0.1rem; */
    background-color: rgb(180, 32, 39);
  }

  .drawer-cell-payments .myredioBox {
    width: auto !important;
  }

  .drawer-cell-payments .myredioBox .myredioleabl {
    width: 90%;
  }

  .drawer-cell-payments .myredioBox .myrediotext {
    width: auto;
  }

  .drawer-cell-payments .myredioBox .myrediotext img {
    width: 90%;
    height: auto;
  }

  .drawer-cell-payments .myredioBox .myredio {
    margin-right: 5px;
  }

  ul {

    /* flex-direction: row; */
    width: 100%;
    /* flex-wrap: wrap;
    display: flex;
    justify-content: center; */
    padding: 0;

    display: flex;
    flex-wrap: wrap;
    margin: 6px 0 26px 0;
  }

  ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* list-style-type: none;
    width: 29.5%;
    margin-right: 2%;
    border-radius: 0.15625rem;
    height: 2.5rem; */
    text-align: center;
    /* line-height: 2.5rem;
    margin-bottom: 1rem;
    border: 1px solid var(--theme-color);
    color: #333333; */
    position: relative;

    width: calc((100% - (10px * 2)) / 3);
    /* height: 56px; */
    min-height: 56px;
    margin-right: 10px;
    margin-top: 8px;
    border-radius: 5px;
    background-color: #fff !important;
    padding: 8px 0;
    box-sizing: border-box;
  }

  /* 商品icon样式 */
  .product-icon {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 24px;
    height: 24px;
    object-fit: cover;
    z-index: 10;
  }

  ul li:nth-child(3n) {
    margin-right: 0;
  }

  ul li:nth-child(-n+3) {
    margin-top: 0;
  }

  ul li div {
    margin: 0;
    /* line-height: 1em;
    height: 1em; */

    color: #565656;
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 0 5px;
  }

  ul li div.bechoice {
    color: #FFFFFF;
  }

  div.des {
    /* line-height: 1rem;
    height: 1rem;
    font-size: .8em;
    color: #999; */

    color: #B42027;
    font-family: 思源黑体;
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
    margin-top: 7px;
    padding: 0 5px;
  }

  .bechoice {
    /*border:2px solid #e43;*/
    color: #fff !important;
    /* background-color: var(--theme-color); */
    background-color: #B42027 !important;
  }

  .bechoice div {
    color: #fff !important;
  }

  li.bechoice div.des {
    color: #fff !important;
  }

  .drawer {
    padding: 20px 10px 0px;
    height: 100%;
    position: relative;

  }
  .drawer .iconfont{
    position: absolute;
    right: 5px;
    top:5px;
    font-size: 18px;
  }


  .drawer .btn-area {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

  }

  .drawer-cell {
    position: relative;
    width: 100%;
    display: flex;
    height: 2em;
    line-height: 2em;
  }

  .drawer-cell.under-line:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 1px;
    color: #e5e5e5;
    border-top: 1px solid #e5e5e5;
    transform: scaleY(.5);
    z-index: 2;
  }

  .drawer-cell_hd,
  .drawer-cell_bd {
    display: inline-block;
  }

  .drawer-cell_hd {
    /* width: 30%; */
    width: 25%;
    text-align: left;
    color: #333;
  }

  .drawer-cell_bd {
    text-align: left;
    /* width: 70%; */
    width: 75%;
    color: #666;
    color: #686777;
    font-family: 思源黑体 CN;
    font-size: 15px;
    font-weight: 400;
    line-height: 23px;
  }

  .half {
    width: 100%;
  }

  .intro {
    overflow-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    font-size: 15px;
    color: #686777;
    line-height: 23px;
  }

  .tag {
    position: absolute;
    width: 40px;
    height: 40px;
    top: -25px;
    right: -10px;

  }

  .flex {
    display: flex;
  }

  .mar-right-5 {
    /* margin-right: 5px; */
    margin-right: 3px;
  }

  /deep/ .yhm .el-input__inner {
    height: 26px !important;
    line-height: 26px !important;
    font-size: 15px;
  }

  .yhm .el-button--primary.is-plain {
    height: 26px;
    color: #fff;
    background: #b82229;
    border-color: #b82229;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
  }

  .xcode {
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
    text-align: left;
  }

  .borderSr {
    border: 1px solid #b22830;
    box-shadow: 0 0 5px #b22830;
    padding: 20px 20px 0;
    z-index: 2;
    border-radius: 9px;
    margin-bottom: 20px;
  }

  .asideShadow {
    box-shadow: 5px 0px 5px -5px black, -5px 0px 5px -5px black;
  }

  .more {
    font-size: 14px;
    color: #b22830;


  }

  .arrowBottom {
    width: 20px;
    height: 11px;
  }

  .arrowTop {
    transform: rotate(180deg);
  }

  .recharge_hurg {
    /* padding: 0 12px; */
  }

  .recharge_hurg .title {
    /* color: #2c3e50;
    font-size: 16px; */
    text-align: left;
    color: rgb(104, 103, 119);
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  .recharge_hurg .wrap_select {
    margin-top: 9px;
  }

  .redclass {
    color: red;
  }
 .radio-flex{
    display: flex;
    align-items: center;
/*    flex-wrap: nowrap;
    flex-direction: row; */
  }
  .radio-flex img{
    width:auto;
    height: 18px;
  }
  .group-flex{
    display: flex;

  }
  @media screen and (min-width:768px){
    .radio-flex img{
      width:auto;
      height: 25px;
    }
    .drawer-cell{
      height: 2em;
      line-height: 2em;
    }
    .intro{
      font-size: 16px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/tabs.vue